
<!-- Show STUB instead of real Razorpay -->
<app-indpaystub
    *ngIf="gd?.isStubEnabled"
    [orderData]="orderData">
</app-indpaystub>

<!-- Show ACTUAL RazorPay only when stub is disabled -->
<div *ngIf="!gd?.isStubEnabled">
    <app-merchant-response></app-merchant-response>

    <div class="in-alert card-body card rounded-card receiving-information" *ngIf="alertEnabled">
        <div>
                 <section class="pymnt_alertinfo_section">
                   {{alertText}}
                </section>
            
        </div>
    </div>
    <div class="order-summary card-body card rounded-card receiving-information" *transloco="let t">
        <div>
            <form (submit)="submitPymntDetail()">

                 <section class="pymnt__section_cc">
                  <ng-container *ngIf="counter$ | async as left">
                     <div  class = "payment-container">
                        <h3><b>{{ t('razorpay.info.header') }}</b>
                            <span class = "time-left">Time Left to Pay - {{ formatMMSS(left) }}</span>
                        </h3>
                    
                        <p>{{ t('razorpay.info.text') }}</p>
                            <div>
                                <button id="rzp-button1" >
                                    {{ t('razorpay.btn.text') }}
                                </button>
                            </div>
                        </div> 
                    </ng-container>
                    
                </section>
                
            </form>
        </div>
    </div>
</div>
